/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { lottieNameToFile } from "./lottie-animation.helper";
import type { AnimationNames } from "./lottie-animation.helper";
import type { AnimationData } from "./lottie-animation.types";

export type LottieDataJson = {
	default: AnimationData;
};

type LazyAnimation = () => Promise<LottieDataJson>;

const animationLoaders: Record<string, LazyAnimation> = {
	v03_6a: () => import("./animations/v03_6a.json"),
	v03_6b: () => import("./animations/v03_6b.json"),
	v03_6c: () => import("./animations/v03_6c.json"),
	v03_6d: () => import("./animations/v03_6d.json"),
	v03_7a: () => import("./animations/v03_7a.json"),
	v03_7b: () => import("./animations/v03_7b.json"),
	v03_7c: () => import("./animations/v03_7c.json"),
	v03_7d: () => import("./animations/v03_7d.json"),
	v03_8a: () => import("./animations/v03_8a.json"),
	v03_8b: () => import("./animations/v03_8b.json"),
	v03_8c: () => import("./animations/v03_8c.json"),
	v03_8d: () => import("./animations/v03_8d.json"),
	v03_9a: () => import("./animations/v03_9a.json"),
	v03_9b: () => import("./animations/v03_9b.json"),
	v03_9c: () => import("./animations/v03_9c.json"),
	v03_9d: () => import("./animations/v03_9d.json"),
};

export async function importLottie(lottie: AnimationNames): Promise<AnimationData | null> {
	const file = lottieNameToFile(lottie);
	const loader = animationLoaders[file];
	if (!loader) {
		console.error("Unknown animation:", file);
		return null;
	}
	try {
		const module = await loader();
		return module.default;
	} catch (err) {
		console.error("Error loading animation:", err);
		return null;
	}
}
